import React from 'react';
import { Modal } from 'react-bootstrap';

function Loading(props) {
    const onHide = (e) => {
        e.preventDefault();
    };

    return (
        <Modal size="sm" show={true} onHide={onHide} aria-labelledby="example-modal-sizes-title-sm" centered className="loading-modal">
            <Modal.Body>
                <div className="d-flex justify-content-center">
                    <div className="spinner-grow text-light" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-light" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-light" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-light" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default Loading;
